// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"canvasSizer_wrapper__1BU-p","sizer":"canvasSizer_sizer__15XWD","bar":"canvasSizer_bar__318RQ"};